import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { surveyPlugin } from 'survey-vue3-ui'
import './assets/css/main.css'

createApp(App).use(router).use(store).use(surveyPlugin).mount('#app')
